import produce from 'immer';

export const CHECK_ORDER_DATE_PENDING = 'checkOrderDate/get/pending';
export const CHECK_ORDER_DATE_FULFILLED = 'checkOrderDate/get/fulfilled';
export const CHECK_ORDER_DATE_REJECTED = 'checkOrderDate/get/rejected';
export const CHECK_ORDER_DATE_RESET = 'checkOrderDate/reset';

export const initialState = {
  loading: false,
  error: null,
  gotHereByBackButton: false,
};

/* eslint-disable default-case, no-param-reassign */
const checkOrderDate = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CHECK_ORDER_DATE_PENDING:
        draft.loading = true;
        draft.error = false;
        break;
      case CHECK_ORDER_DATE_FULFILLED:
        draft.loading = false;
        break;
      case CHECK_ORDER_DATE_REJECTED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case CHECK_ORDER_DATE_RESET:
        return initialState;
      case 'RETURN_TO_PREVIOUS_MACRO_PATH':
        draft.gotHereByBackButton = true;
        break;
      default:
        break;
    }
  });
export default checkOrderDate;
